import axios from '@/libs/api.request'

export const upload = (data, config) => {
  return axios.request({
    method: 'post',
    url: '/file/upload',
    ...config,
    data
  })
}

export const seriesResolve = (data) => {
  return axios.request({
    method: 'post',
    url: '/series/resolve',
    data
  })
}

export const importName = (data) => {
  return axios.request({
    method: 'post',
    url: '/play/importName',
    data
  })
}
